<div class="container">
	<h3 class="greeting title" [ngClass]="{error: !isSuccess}">{{ ('MSG.EMAIL_VERIFY_' + (isSuccess ? 'SUCCESS' : 'FAILED')) | translate}}</h3>
	<a routerLink="/auth/login" mat-flat-button class="resend-email" color="accent">Go To Loggin</a>
</div>